






















































































import { cloneDeep } from 'lodash';
import Vue from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { draggableDelay } from '@/web/utils/draggable';
import draggable from 'vuedraggable';
import { errorToMessage } from '@/core/utils/errors';

interface AnswerFormData extends QuizAnswerResponse {
  isLocal?: boolean;
  removed?: boolean;
}

interface FormModal extends QuizQuestionResponse {
  answers: AnswerFormData[];
}

export default Vue.extend({
  components: {
    ValidationObserver,
    ValidationProvider,
    draggable,
  },
  props: {
    data: {
      type: Object as () => QuizQuestionResponse,
      required: true,
    },
    staticAnswers: {
      type: Boolean,
      default: null,
    },
    multiSelect: {
      type: Boolean,
      default: false,
    },
    showImageUpload: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    minAnswers: {
      type: Number,
      default: 2,
    },
    showManualCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      draggableDelay,
      form: {} as FormModal,
    };
  },
  computed: {
    hideDeleteAnswer() {
      const answersNum = this.form.answers.filter(answer => !answer.removed)
        .length;
      return this.staticAnswers || this.minAnswers >= answersNum;
    },
    answers: {
      get() {
        return this.form.answers;
      },
      set(answers: AnswerFormData[]) {
        answers.forEach((answer, index) => (answer.position = index));
        this.form.answers = answers;
      },
    },
  },
  methods: {
    toggleAnswerIsCorrect(isCorrect, answerId) {
      this.form.answers.forEach(answer => {
        if (answer.id === answerId) {
          const isOneSelected =
            this.form.answers.filter(answer => answer.is_correct).length === 1;
          if (!(this.showManualCheck && answer.is_correct && isOneSelected)) {
            answer.is_correct = isCorrect;
          }
        } else if (!this.multiSelect) {
          answer.is_correct = false;
        }
      });
    },
    onCheckboxGroupInputChanged(value, answer) {
      answer.answer_label = value;
    },
    toForm(quizQuestion: QuizQuestionResponse): FormModal {
      const form = { ...quizQuestion };
      form.answers = cloneDeep(quizQuestion.answers) || [];

      return form;
    },
    formToQuizQuestionData(form) {
      const data = { ...form };
      delete data.answers;
      return data;
    },
    getAnswerPromise(answer: AnswerFormData) {
      try {
        let data = { ...answer } as any;
        const quizId = this.data.quiz;
        const questioId = this.data.id;
        const answerId = answer.id;
        let action;

        if (answer.isLocal) {
          action = 'quiz/createQuizAnswer';
        } else if (answer.removed) {
          action = 'quiz/deleteQuizAnswer';
          data = answerId;
        } else {
          action = 'quiz/updateQuizAnswer';
        }
        return this.$store.dispatch(action, {
          quizId,
          questioId,
          data,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t('NOTIFICATIONS.TEXT.REQUEST_FAILED')}: ${error}`
          ),
          duration: -1,
        });
      }
    },
    formAnswersToData(answer) {
      answer = { ...answer };
      answer.answer_image = answer.answer_image?.id;
      return answer;
    },
    async save() {
      try {
        await Promise.all(
          this.form.answers
            .map(this.formAnswersToData)
            .map(this.getAnswerPromise)
        );
        const data = this.formToQuizQuestionData(this.form);
        const question = await this.$store.dispatch('quiz/updateQuizQuestion', {
          quizId: this.data.quiz,
          data,
        });
        this.$store.dispatch('quiz/refreshQuizQuestion', question);
        this.form = this.toForm(question);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t(
              'QUIZZES.NOTIFICATIONS.FAILED_TO_UPDATE_QUIZ_QUESTION'
            )}: ${error}`
          ),
          duration: -1,
        });
      } finally {
        this.$refs.form?.reset();
      }
    },
    onDeleteField(answer) {
      answer.removed = true;
      this.answers = Object.assign([] as AnswerFormData, this.answers);
    },
    addAnswer() {
      const localAnswer = this.getLocalEmptyAnswer();
      localAnswer.quiz_question = this.data.id;
      localAnswer.position = this.answers.length;
      this.answers.push(localAnswer);
    },
    getPlaceholder(type) {
      if (type === 'image_check') {
        return this.$t('QUIZZES.PLACEHOLDER.IMAGE_DESCRIPTION');
      }
      return this.$t('QUIZZES.PLACEHOLDER.TYPE_ANSWER');
    },
    getLocalEmptyAnswer(quiz_question, position) {
      const answer_type =
        this.form.question_type === 'single_image' ? 'image_check' : 'check';

      return {
        id: `local-${Math.random() * 10}`,
        quiz_question,
        answer_type,
        answer_label: '',
        question_text: '',
        is_correct: false,
        isLocal: true,
        position,
      };
    },
  },
  watch: {
    'data.id': {
      handler() {
        this.form = this.toForm(this.data);
      },
      immediate: true,
    },
  },
});
